
import moment from 'moment'
import { mapGetters,mapActions } from 'vuex'
import promoData from '@/data/promo.json'

export default {
  data() {
    return{
      showSkeleton: true, // skeleton is shown initially
      promoData, // Importing promo data
      bannerHidden: false, // Controls overall visibility, including permanent dismissal
      bannerCookieName: 'webinarBannerDismissed', // Cookie name
      showWebinarBanner: false, // Controls visibility of the banner
      isHeaderFixed: false,
      scrollThreshold: 45,
    }
  },
  computed: {
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      regionReady: 'geolocation/isRegionReady',
      userRegion: 'user/region',
      webinarBannerDismissed: 'user/webinarBannerDismissed',
      currentLabel: 'cart/getPriceLabel',
      detectedCountry: 'geolocation/detectedCountry',
    }),
    activeFlag(){
      const fl = this.$nuxt.$options.filters.flagFromLabel(this.currentLabel,this.detectedCountry)
      console.log('HEADER FLAG',fl)
      return fl
    },
    flagLink(){
      const fl = this.flag
      if(fl === 'fi-gb'){
        return ''
      } else if(fl === 'fi-ie'){
        return '/ie'
      } else if(fl === 'fi-au'){
        return '/au'
      } else if(fl === 'fi-ca'){
        return '/ca'
      } else if(fl === 'fi-eu'){
        return ''
      } else if(fl === 'fi-za'){
        return '/za'
      } else if(fl === 'fi-us'){
        return '/en-us'
      } else {
        return ''
      }
    },
    region(){
      console.log('MENU REGIONS',this.userRegion, this.detectedRegion)
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },
    regionVar(){
      // console.log('COMPUTING REGION FOR MENU TO SHOW...',this.$props.region, this.detectedRegion, this.userRegion)
      const regionVar = this.$props.region
      if (regionVar === 'ie' || regionVar === 'ca' || regionVar === 'au' || regionVar === 'za' || regionVar === 'en-us') {
        return '/'+regionVar
      }
      if(regionVar === 'eu'){
        return ''
      }
      return ''
    },
    ended() {
      // Check if webinarDatetime exists
      if (!promoData.webinarDatetime) {
        console.warn('promoData.webinarDatetime not found. Countdown will not start.');
        return true; // If no webinar date, treat as ended
      }

      const targetDate = moment(promoData.webinarDatetime).tz('Europe/London');
      const todayDate = moment().tz(this.detectedTimezone || 'Europe/London');

      return todayDate.isAfter(targetDate);
    }
    // showWebinarBanner() {
    //   return !this.webinarBannerDismissed
    // }
  },
  mounted() {
    this.showSkeleton = false; // hide skeleton immediately on client mount
    // TRACKING
    if ((window.location.href.includes("teach-english-abroad") || window.location.href.includes("teach-english-online") || window.location.href.includes("tesol")) && !this.ended) {
      this.showWebinarBanner = true; // Show banner if on the specific page
    } else {
      this.showWebinarBanner = false; // Hide banner on other pages
    }
    // this.checkBannerDismissed(); // Check cookie on mount
    this.$nextTick(function () {
          if ( window ) {
            if ((window.location.href.includes("teach-english-abroad") || window.location.href.includes("teach-english-online") || window.location.href.includes("tesol")) && !this.ended) {
              if (this.$refs.webinarBanner) {
                window.addEventListener('scroll', this.handleScroll);
                this.handleScroll(); // Initial state check
              }
            }
          }
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions({
      updateWebinarBannerDismissed: 'pages/updateWebinarBannerDismissed', // map `this.add()` to `this.$store.commit('increment')`
    }),
    hideBannerPermanently() {
      // this.showWebinarBanner = false;
      this.bannerHidden = true;
      this.updateWebinarBannerDismissed(true); // Update Vuex state
      this.$cookies.set(this.bannerCookieName, 'true', { expires: 7 }); // Set cookie to expire in 7 days
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.isHeaderFixed = currentScrollPosition >= this.scrollThreshold;
      if(currentScrollPosition <= this.scrollThreshold){
        this.$refs.webinarBanner.style.marginBottom = "-" + currentScrollPosition + "px"; // Adjust margin to hide the banner when scrolling
      } else {
        // this.$refs.webinarBanner.style.marginBottom = "0px"; // Reset margin when not at the top
      }
    },
  }
}
